const IconComponent = ({
    icon,
    alt="",
    size=40,
    style,
    ...other
}) => {
    return (
        <>
            <img 
                src={icon} 
                alt={alt}
                style={{
                    width: size,
                    height: size,
                    ...style
                }} 
                {...other}
            />
        </>
    );
}

export default IconComponent;